























































































































































































































































































































































































































































































































































































































/* eslint-disable @typescript-eslint/indent */
import Vue from 'vue'
import ActiveModInset from '../components/_ActiveModInset.vue'
import AmmoCaseInset from '../../mech_loadout/components/mount/weapon/_AmmoCaseInset.vue'
import { ActivationType, Damage, PilotTalent, Range, WeaponSize, WeaponType } from '@/class'
import CbCard from '../../mech_loadout/components/mount/_CbCard.vue'

export default Vue.extend({
  name: 'weapon-attack',
  components: { AmmoCaseInset, ActiveModInset, CbCard },
  props: {
    item: {
      type: Object,
      required: true,
    },
    mech: {
      type: Object,
      required: true,
    },
    mount: {
      type: Object,
      required: false,
      default: null,
    },
    aux: { type: Boolean },
    improv: { type: Boolean },
    barrage: { type: Boolean },
    reaction: { type: Boolean },
  },
  data: () => ({
    tab: 0,
    ammoCost: 0,
    overkillHeat: 0,
    autoOverkillString: '',
    ammoDamage: '',
    accuracy: 0,
    difficulty: 0,
    attackRoll: null,
    rollResultString: null,
    rollAccuracyResults: [],
    attackQuick: false,
    attackFree: false,
    hit: false,
    missed: false,
    damageRolls: [],
    damageResultString: null,
    bonusDamage: null,
    kill: false,
    confirmed: false,
    resetAttackRoll: false,
  }),
  computed: {
    state() {
      return this.mech.Pilot.State
    },
    noDamageItem() {
      return !this.item.Damage.length
    },
    missText() {
      if (this.reliable) return 'Glancing hit'
      switch (this.item.WeaponType) {
        case 'Rifle':
        case 'Cannon':
          return 'Shot wide'
        default:
          return 'No effect'
      }
    },
    overkill() {
      if (this.item.ProfileTags.some(x => x.IsOverkill)) return true
      if (this.item.Mod && this.item.Mod.AddedTags.some(x => x.IsOverkill)) return true
      return false
    },
    crit() {
      return this.attackRoll && this.attackRoll >= 20
    },
    attacked() {
      return this.attackQuick || this.attackFree
    },
    hardpoints() {
      if (!this.mount) return false
      if (this.item.NoCoreBonus) return false
      return (
        this.mount.Bonuses &&
        this.mount.Bonuses.find(x => x.ID === 'cb_auto_stabilizing_hardpoints')
      )
    },
    overpower() {
      if (!this.mount) return false
      if (this.item.NoCoreBonus) return false
      return this.mount.Bonuses && this.mount.Bonuses.find(x => x.ID === 'cb_overpower_caliber')
    },
    armoryLevel() {
      if (
        this.improv ||
        this.item.Size !== WeaponSize.Main ||
        this.item.WeaponType === WeaponType.Melee
      )
        return 0
      const tal = this.mech.Pilot.TalentsController.Talents.find(
        (x: PilotTalent) => x.Talent.ID === 't_walking_armory'
      )
      if (!tal) return 0
      return tal.Rank
    },
    getRange() {
      if (!this.item) return []
      return Range.CalculateRange(this.item, this.mech)
    },
    getDamage() {
      if (!this.item) return []
      return Damage.CalculateDamage(this.item, this.mech)
    },
    isSmart() {
      if (this.item.ProfileTags.some(x => x.IsSmart)) return true
      if (this.item.Mod && this.item.Mod.AddedTags.some(x => x.IsSmart)) return true
      return false
    },
    reliable() {
      const r = this.item.ProfileTags.find(x => x.ID === 'tg_reliable')
      return Number(r ? r.Value : 0)
    },
    minAccuracy() {
      let bonus = 0
      if (this.item.ProfileTags.some(x => x.ID === 'tg_accurate')) bonus += 1
      if (this.item.Mod && this.item.Mod.AddedTags.some(x => x.ID === 'tg_accurate')) bonus += 1
      if (this.hardpoints) bonus += 1
      return bonus
    },
    minDifficulty() {
      if (this.item.ProfileTags.some(x => x.ID === 'tg_inaccurate')) return 1
      if (this.item.Mod && this.item.Mod.AddedTags.some(x => x.ID === 'tg_inaccurate')) return 1
      return 0
    },
    summedDamage() {
      let dmg = 0
      this.damageRolls.forEach(v => {
        dmg += parseInt(v)
      })
      if (this.bonusDamage) dmg += parseInt(this.bonusDamage)
      return dmg
    },
    finalDamage() {
      return this.reliable > this.summedDamage ? this.reliable : this.summedDamage
    },
  },
  watch: {
    tab(newval: number) {
      this.item.SetProfileSelection(newval, true)
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    setAmmoCost(cost) {
      this.ammoCost = cost
    },
    setAmmoDamage(damage) {
      this.ammoDamage = damage
    },
    setDamage(index, damage) {
      Vue.set(this.damageRolls, index, damage.total)
      this.overkillHeat += damage.overkill
    },
    setBonusDamage(damage) {
      this.bonusDamage = damage.total
      this.overkillHeat += damage.overkill
    },
    confirm(): void {
      this.confirmed = true
      const actionObj = {
        accuracy: this.accuracy - this.difficulty,
        hit: this.hit,
        damage: this.summedDamage,
        kill: this.kill,
        activation: this.improv
          ? ActivationType.Full
          : this.attackQuick
          ? ActivationType.Quick
          : ActivationType.Free,
      }
      let cost = 1
      cost = this.item.Cost
      this.item.Use(cost, actionObj.activation === ActivationType.Free)
      if (this.ammoCost) this.state.SpendAmmoCost(this.ammoCost)
      this.mech.CurrentHeat += this.item.ProfileHeatCost
      this.mech.CurrentHeat += this.overkillHeat
      this.mech.Pilot.State.LogAttackAction('ATTACK', this.item.Name, this.summedDamage, this.kill)
      this.$emit('confirm', actionObj.activation === ActivationType.Free)
    },
    reset() {
      this.mech.Pilot.State.UndoLogAttackAction(
        'ATTACK',
        this.item.Name,
        this.summedDamage,
        this.kill
      )
      if (this.ammoCost) this.state.RefundAmmoCost(this.ammoCost)
      this.init()
      this.$emit('reset')
    },
    init(): void {
      this.ammoCost = 0
      this.ammoDamage = ''
      this.accuracy = this.minAccuracy
      this.difficulty = this.minDifficulty
      this.attackRoll = null
      this.rollResultString = null
      this.rollAccuracyResults = []
      this.attackQuick = false
      this.attackFree = false
      this.hit = false
      this.missed = false
      this.damageRolls = []
      this.damageResultString = null
      this.bonusDamage = null
      this.kill = false
      this.confirmed = false
      this.overkillHeat = 0
      this.resetAttackRoll = false
      this.$nextTick(function () {
        this.resetAttackRoll = true
      })
    },
  },
})
